import { Box, Breadcrumbs, Button, Fade, FormControl, Link, Paper, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";

import { LinkVariants } from "Custom/StylesAppSpecific/LinkVariants";
import { BreadcrumbBox } from "./BreadcrumbBox";

export const UserPageBreadcrumb: React.FunctionComponent = () => {
    const linkClasses = LinkVariants();

    //useEffect below only gets run on initial render
    useEffect(() => {
        /*         // *optional* passing the router into the viewmodel so we can navigate from there
        console.log("First render");
        //This gets run when the page is exited
        return () => {
            console.log("Unmounting user detail breadcrumb");
        }; */
    }, []);

    return (
        <BreadcrumbBox>
            <Box className="breadcrumb-wrapper">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link color="inherit" href="https://www.hdsharman.co.uk/">
                        Home
                    </Link>
                    <Typography color="textPrimary">Quick, accurate quotes</Typography>
                </Breadcrumbs>
                <Box className="contact">
                    <Typography className={linkClasses.rulertel}>Call now &nbsp;</Typography>
                    <Link variant="caption" className={linkClasses.rulertel} href="tel:+441298812371">
                        +44 (0)1298 812371
                    </Link>
                </Box>
            </Box>
        </BreadcrumbBox>
    );
};
